import React from 'react';
import { connect } from 'react-redux';

class PositiveImportantInfo extends React.Component {

    // FIXME Styles/layout
    render() {
        return (
            <div>
                <div style={{color: 'red', fontWeight: 'bold'}}>{this.props.strings.IMPORTANT_POSITIVE_MESSAGE}</div><br/>
                <div>
                    <p style={{ color: 'red', fontWeight: 'bold' }}>{this.props.strings.IMPORTANT_POSITIVE_MESSAGE_1}<a href={this.props.strings.COVID_MAIN_PAGE_LINK}>{this.props.strings.IMPORTANT_POSITIVE_MESSAGE_1B}</a>
                        {this.props.strings.IMPORTANT_POSITIVE_MESSAGE_1C}
                    </p>
                </div>
                <div>
                    <p>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1A}
                        <strong>
                            <a href={this.props.strings.TREATMENT_LINK}>{this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1B}</a>
                        </strong>
                        {this.props.strings.IMPORTANT_PAXLOVID_MESSAGE_1C}
                    </p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
    }
}

const ConnectedPositiveImportantInfo = connect(
    mapStateToProps
)(PositiveImportantInfo);
export default ConnectedPositiveImportantInfo;
